import { getFeatureFlags } from 'utils/feature-flags';
import type {
  Fetcher,
  FetcherArgs,
  PreloadOnlyFetcher,
  PreloadOnlyFetcherArgs,
} from './fetcher-types';

export function withFeatureFlag<PathParamKey extends string = string>(
  flagKey: string,
  fetcher: Fetcher<PathParamKey>,
): Fetcher<PathParamKey>;

export function withFeatureFlag(flagKey: string, fetcher: PreloadOnlyFetcher): PreloadOnlyFetcher;

export function withFeatureFlag<PathParamKey extends string = string>(
  flagKey: string,
  fetcher: Fetcher<PathParamKey> | PreloadOnlyFetcher,
): Fetcher<PathParamKey> | PreloadOnlyFetcher;

export function withFeatureFlag<PathParamKey extends string = string>(
  flagKey: string,
  fetcher: Fetcher<PathParamKey> | PreloadOnlyFetcher,
): Fetcher<PathParamKey> | PreloadOnlyFetcher {
  return (args: FetcherArgs<PathParamKey> | PreloadOnlyFetcherArgs) => {
    if ('preloadOnly' in args) {
      (fetcher as PreloadOnlyFetcher)(args);

      return () => {};
    }

    return (dispatch: WtrDispatch) => {
      const flags = getFeatureFlags();

      if (!flags[flagKey]) {
        return Promise.resolve();
      }

      return dispatch((fetcher as Fetcher<PathParamKey>)(args));
    };
  };
}
